/**
 * 다시 온 손님에게 "지난 대화 이어보기" 카드를 띄울지 판정한다.
 *
 * 헤더에 '이전 대화' 버튼이 이미 있지만 작은 아이콘이고, 업체 설정에 따라 휴대폰에선 숨는다.
 * 실측(양주잼잼 웹, 2026-07-01 ~ 10-09): 방문자 82명 중 12명(15%)이 다른 날 다시 와서 새 대화를 열었다.
 * 그 손님에게만 대화창 맨 위에 카드 한 장을 띄운다 — 홈·대화 탭을 두면 나머지 85%가 질문 전에
 * 한 단계를 더 거친다(2026-10-09 결정).
 *
 * 표시는 손님 브라우저에만 남는다(localStorage). 서버 대화가 실제로 있는지는 카드를 눌렀을 때
 * `/api/widget-history` 가 판정한다 — 미리 조회하면 위젯을 열 때마다 요청이 하나 는다.
 */

/** 이보다 오래된 표시는 카드를 띄우지 않는다. */
export const RESUME_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;
/** 카드에 보일 질문 길이(글자). */
const SNIPPET_CHARS = 40;

export type ResumeMarker = { ts: number; q: string };

/** 손님이 서버에 질문을 보낼 때 남길 값. 이모지가 반쪽 나지 않게 글자 단위로 자른다. */
export function buildResumeMarker(question: string, now: number): string {
  const flat = question.replace(/\s+/g, ' ').trim();
  const chars = Array.from(flat);
  const q = chars.length > SNIPPET_CHARS ? chars.slice(0, SNIPPET_CHARS).join('') + '…' : flat;
  return JSON.stringify({ ts: now, q });
}

/** 저장된 값을 읽어 카드를 띄울 만하면 돌려준다. 깨진 값·미래 시각·7일 넘은 값은 null. */
export function readResumeMarker(raw: string | null, now: number): ResumeMarker | null {
  if (!raw) return null;
  try {
    const v = JSON.parse(raw) as Partial<ResumeMarker>;
    if (typeof v.ts !== 'number' || typeof v.q !== 'string' || !v.q) return null;
    const age = now - v.ts;
    if (age < 0 || age > RESUME_MAX_AGE_MS) return null;
    return { ts: v.ts, q: v.q };
  } catch {
    return null;
  }
}
